export default __webpack_public_path__ + "static/media/cpanel.814f24d8.svg";